// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__7CYSB","unreadBadge":"styles_unreadBadge__1QOvo","modalContent":"styles_modalContent__1HgJU","modal":"styles_modal__3ae1J"};